import { requestJson } from "@/lib/api";
import type { AnswerType, EnrollmentStatus } from "@/lib/adminSelectionApi";

// Public candidate portal. Authorization is the 6-char access code only (carried in the body).
// The backend only ever returns candidate-visible content — never criteria, scores, ranking,
// evaluator notes or the correction guidance.

export interface CandidateQuestion {
  id: string;
  orderIndex: number;
  statement: string;
  helpText: string | null;
  answerType: AnswerType;
  required: boolean;
  options: string | null;
  meta: string | null;
  valueText: string | null;
  valueJson: string | null;
}

export interface CandidateStage {
  id: string;
  orderIndex: number;
  stageKey: string;
  title: string;
  meta: string | null;
  complete: boolean;
  questions: CandidateQuestion[];
}

export interface CandidateFicha {
  enrollmentId: string;
  processName: string;
  jobName: string | null;
  status: EnrollmentStatus;
  candidateName: string;
  stages: CandidateStage[];
  savedAt: string | null;
  canSubmit: boolean;
}

export interface SaveResult {
  savedAt: string | null;
}

const BASE = "/api/v1/selecao/candidato";

export const candidateAccess = (code: string) =>
  requestJson<CandidateFicha>(`${BASE}/acesso`, { method: "POST", body: { code } });

export const candidateSaveAnswer = (
  code: string,
  questionId: string,
  valueText: string | null,
  valueJson: string | null,
) =>
  requestJson<SaveResult>(`${BASE}/resposta`, {
    method: "POST",
    body: { code, questionId, valueText, valueJson },
  });

export const candidateSubmit = (code: string) =>
  requestJson<CandidateFicha>(`${BASE}/enviar`, { method: "POST", body: { code } });
